import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { usePlotContext } from '../../hooks';
import { calculateTicksNumber } from '../../utils';
import { Ticks } from './Ticks';
export default function BottomAxis({ id, displayGridLines, hidden = false, label, labelSpace, labelStyle, fontSize, tickStyle, hiddenTicks = false, tickEmbedded, tickLength, hiddenSecondaryTicks, }) {
    const { axisContext, plotWidth, plotHeight } = usePlotContext();
    // Calculates the main axis values
    const { scale, scientific } = axisContext[id] || {};
    const ticks = useMemo(() => {
        const ticksNumber = calculateTicksNumber(plotWidth, scientific, scale === null || scale === void 0 ? void 0 : scale.domain());
        return (scale === null || scale === void 0 ? void 0 : scale.ticks(ticksNumber)) || [];
    }, [scale, scientific, plotWidth]);
    const range = (scale === null || scale === void 0 ? void 0 : scale.range()) || [0, 0];
    // Create gridlines
    const gridlines = useMemo(() => {
        if (!displayGridLines || !scale)
            return null;
        return (_jsx("g", Object.assign({ className: "gridLines" }, { children: ticks.map((val) => (_jsx("line", { x1: scale(val), x2: scale(val), y1: plotHeight, y2: "0", stroke: "black", strokeDasharray: "2,2", strokeOpacity: 0.5 }, val))) }), void 0));
    }, [displayGridLines, ticks, scale, plotHeight]);
    const tickDirection = tickEmbedded ? -1 : 1;
    const tickLen = tickDirection * tickLength;
    const tickTextPosition = tickEmbedded ? 16 : 16 + tickLen;
    return (_jsxs("g", Object.assign({ className: "axis" }, { children: [gridlines, !hidden && (_jsxs("g", Object.assign({ className: "ticks", transform: `translate(0, ${plotHeight})` }, { children: [_jsx("line", { x1: range[0], x2: range[1], stroke: "black" }, void 0),
                    _jsx(Ticks, { scientific: scientific, scale: scale, hidden: hiddenTicks, ticks: ticks, style: tickStyle, hiddenSecondaryTicks: hiddenSecondaryTicks, anchor: "middle", getPositions: (val) => ({
                            line: { x1: val, x2: val, y2: tickLen },
                            text: { x1: val, y1: tickTextPosition },
                        }) }, void 0)] }), void 0)),
            label && !hidden && (_jsx("text", Object.assign({ x: plotWidth / 2, y: plotHeight + labelSpace + fontSize, fontSize: fontSize, textAnchor: "middle", style: labelStyle }, { children: label }), void 0))] }), void 0));
}
//# sourceMappingURL=BottomAxis.js.map